import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import GLHerosIcon from '@/assets/images/icons/GLHerosIcon.svg';
import primaryCTA from '@/assets/images/icons/Primary-CTA_Large.svg';
import { GoldLoanSEO } from '@/utils/constants/MetaData';

import accessGold from '../../../assets/images/icons/access-gold.svg';
import step1 from '../../../assets/images/icons/door-step.svg';
import step2 from '../../../assets/images/icons/mfo-glfh-branch.svg';
import processFee from '../../../assets/images/icons/mfone-gl-landing1.svg';
import { TestimonialCarousel } from '../digital-gold';
import WhyOneMuthoot from '../Forex/LandingPage/WhyOneMuthoot';
import AtrractiveSchemes from '../gold-loan/AttractiveSchemes';
import GlfhFaq from '../gold-loan/GlfhFaq';
import LTVCalcualator from '../gold-loan/LTVCalcualator';
import AllInOne from './AllInOne';
import { CarouselGlfh } from './CarouselGlfh';

export const GlfhLanding = () => {
  return (
    <>
      <Head>
        <title>{GoldLoanSEO.metaTitle}</title>
        <meta name="description" content={GoldLoanSEO.metaDescription} />
        <meta
          property="og:description"
          content={GoldLoanSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/gold-loans/"
        />
      </Head>
      <main className="home">
        <section className="bg bg--dark home__hero om-gl-main-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <h1 className="section__title text--white">
                  {/* All your financial <br />
                needs in <span className="text--yellow">ONE</span> place */}
                  Make Your <br /> Gold Work
                </h1>
                <p className="section__desc text--white">
                  {/* Explore our suite of simple, affordable, and accessible
                  products for every financial need */}
                  Gold Loans at your convenience
                </p>
                <div className="d-flex align-items-center appLinks">
                  <Link
                    href="https://qrco.de/mfone"
                    target="_blank"
                    id="gold-loans_play-store"
                  >
                    <Image
                      style={{ color: undefined }}
                      // className="img-fluid"
                      src={primaryCTA}
                      alt="Google Play Store"
                    />
                    <span className="sr-only">Google Play Store</span>
                  </Link>
                </div>
              </div>

              <div className="col-lg-4">
                <Image
                  style={{ color: undefined }}
                  src={GLHerosIcon}
                  height={956}
                  width={956}
                  // style={{top:-60}}
                  // height={556}
                  // width={856}
                  // style={{
                  //   position: 'absolute',
                  // }}
                  className="mfone-glhome-hero-image absolute_position"
                  alt="download-app"
                />
              </div>
            </div>
          </div>
          {/* <Image 
style={{ color: undefined }}
          src={GLHerosIcon}
          style={{
            position: "absolute",
            height: "200%",
            width: "200%",
            bottom: "-100px",
            // left: "100px",
          }}
          alt="download-app"
        /> */}
        </section>

        <div className="mfo-carousel-glfh">
          <CarouselGlfh />
        </div>
        {/* Golad Loan Calculator Section */}
        <LTVCalcualator />

        {/* Most Attractive Schemes Section */}
        <AtrractiveSchemes />

        <section className="with-padding home__safe">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h2 className="text--black section__title">
                  Your Gold is{' '}
                  {/* <span className="text--yellow">Your Gold is Safe</span> at all times */}
                  Safe at All Times, From Your Home, Straight Into Our Vault
                </h2>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-6 safe__card-col">
                    <div className="safe__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={step1}
                        alt="30 minutes door step service"
                      />
                      <p className="text--gray text--regular title">
                        Loan Manager home visits are OTP-verified
                      </p>
                    </div>
                  </div>
                  <div className="col-6 safe__card-col">
                    <div className="safe__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={step2}
                        alt="vault"
                      />
                      <p className="text--gray text--regular title">
                        Gold stored at Muthoot FinCorp branch near you
                      </p>
                    </div>
                  </div>
                  <div className="col-6 safe__card-col mb-0">
                    <div className="safe__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={processFee}
                        alt="process Fee"
                      />
                      <p className="text--gray text--regular title">
                        BIS Standard 9400 compliance for gold storage & safety
                      </p>
                    </div>
                  </div>
                  <div className="col-6 safe__card-col mb-0">
                    <div className="safe__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={accessGold}
                        alt="access Gold"
                      />
                      <p className="text--gray text--regular title">
                        Gold is insured & tracked during transit
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <WhyOneMuthoot />

        {/*  videos section */}
        {/* <VideosSection /> */}

        {/* Testimonial Section */}
        <section className="bg bg--light">
          <div className="home__customer">
            <div className="container">
              <h2 className="section__title-small text--bold text--black text-center">
                The Customer Is Always Right
              </h2>
              <p className="section__desc text--gray text-center">
                Trust is a key component to the way we treat our customers
              </p>
            </div>
            <TestimonialCarousel />
          </div>
        </section>
        {/* <section className="bg bg--dark "> */}
        <AllInOne />
        {/* </section> */}
        <section className="home__faq with-padding">
          <GlfhFaq />
        </section>
      </main>
    </>
  );
};
